export enum StyleVersion {
  Default = 1,
  RingCentral = 2,
}
